import React from 'react';
import WHStep1 from './WHStep1';

export default function WHStep1Conatiner({ formikProp }) {
  return <WHStep1 formikProp={formikProp} />;
}
